/**
 * Services Configuration
 * List of all available services offered
 */

export const SERVICES_LIST = [
  {
    id: 'weight-loss',
    name: 'Weight Loss',
    description: 'Personalized weight loss programs and guidance',
    category: 'Health'
  },
  {
    id: 'weight-gain',
    name: 'Weight Gain',
    description: 'Healthy strategies for weight gain and muscle building',
    category: 'Health'
  },
  {
    id: 'child-nutrition',
    name: 'Child Nutrition',
    description: 'Nutritional assessment and diet planning for children',
    category: 'Health'
  },
  {
    id: 'skin-care',
    name: 'Skin Care',
    description: 'Dermatological advice and skin care routines',
    category: 'Wellness'
  },
  {
    id: 'business',
    name: 'Business',
    description: 'Business consulting and strategy services',
    category: 'Consulting'
  }
];

/**
 * Get services grouped by category
 */
export const getServicesByCategory = () => {
  const grouped = {};

  SERVICES_LIST.forEach(service => {
    if (!grouped[service.category]) {
      grouped[service.category] = [];
    }
    grouped[service.category].push(service);
  });

  return grouped;
};

/**
 * Get service by ID
 */
export const getServiceById = (id) => {
  return SERVICES_LIST.find(service => service.id === id);
};

/**
 * Get service names for dropdown
 */
export const getServiceOptions = () => {
  return SERVICES_LIST.map(service => ({
    value: service.name,
    label: service.name,
    category: service.category
  }));
};

export default SERVICES_LIST;
